module.exports = __webpack_public_path__ + "img/vote-title@2x.08cd66ab.png";